module.exports = __webpack_public_path__ + "img/Gas Valve wiring.278fec44.png";